// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as CircularLoader$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as CrmControlledReleaseHook from "../hook/CrmControlledReleaseHook.bs.js";
import * as CrmControlledReleaseProvider from "../context/CrmControlledReleaseProvider.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function getAccessType(page_config, selected_page_name) {
  var accessInfo = Belt_Array.getBy(page_config, (function (page_info) {
          return page_info.view_name === selected_page_name;
        }));
  if (accessInfo !== undefined) {
    return accessInfo.version_access;
  } else {
    return /* STABLE */1;
  }
}

function CrmControlledReleaseHOC(Props) {
  var children = Props.children;
  var crmControlledReleaseData = CrmControlledReleaseHook.useBetaUserConfig(undefined);
  switch (crmControlledReleaseData.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        return React.createElement(CrmControlledReleaseProvider.make, CrmControlledReleaseProvider.makeProps({
                        adminBetaAccessData: crmControlledReleaseData._0
                      }, Curry._1(children, undefined), undefined));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: crmControlledReleaseData._0
                  });
    
  }
}

var make = CrmControlledReleaseHOC;

export {
  getAccessType ,
  make ,
  
}
/* react Not a pure module */
